// extracted by mini-css-extract-plugin
export default {"container":"customSlotsModal_container__U3wCS","btns":"customSlotsModal_btns__aJZ1Q"};